import React from 'react'

function Test() {
  return (
    <div>
      Testing a new homepage 
    </div>
  )
}

export default Test;
